/* eslint-disable */

// fileUpload.js
(function () {
  const fileUpload = {
    
    init() {
      const uploads = document.querySelectorAll('.file-upload');
      Array.prototype.forEach.call(uploads, (upload) => {
        const label = upload.querySelector('.btn');
        const labelVal = label.innerHTML;
        const input = upload.querySelector('input');

        input.addEventListener('change', (e) => {
          let fileName = '';
          if (e.target.files && e.target.files.length > 1) {
            fileName = (e.target.getAttribute('data-multiple-caption') || '').replace('{count}', e.target.files.length);
          } else {
            fileName = e.target.value.split('\\').pop();
          }
          if (fileName) {
            label.innerHTML = fileName;
          } else {
            label.innerHTML = labelVal;
          }
        });
      });
    },
  };
  
  document.addEventListener('DOMContentLoaded', () => {
    fileUpload.init();
  });
}());
// end fileUpload.js

/* eslint-enable */
